import _ from 'lodash'

import {
  FETCH_TOURS_BEGIN,
  FETCH_TOURS_SUCCESS,
  FETCH_TOURS_ERROR
} from '../actions/fetchTours'

const initialState = {
  loading: false,
  error: null,
  data: null
}

export default function fetchTours(state = initialState, action) {
  switch (action.type) {
    case FETCH_TOURS_BEGIN:
      return Object.assign({}, state, {
        loading: true
      })
    case FETCH_TOURS_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        data: action.payload
      })
    case FETCH_TOURS_ERROR:
      return Object.assign({}, state, {
        loading: false,
        error: action.payload
      })
    default:
      return state
  }
}

export const getTours = state => _.get(state, 'toursData.data')
export const getToursError = state => _.get(state, 'toursData.error')
export const getToursLoading = state => _.get(state, 'toursData.loading')
